<div 
	[ngClass]="CLASS_NAME"
	*ngFor="let image of images; let i = index;"
    [style.width]="image.computedWidth"
    [style.height]="image.computedHeight"
    [style.float]="'left'"
    [style.margin]="image.margin"
    [style.background]="'#eeeeee'"
    [style.lineHeight]="0">
	<img 
        #imageElem
        [src]="image.preview || image.full" 
        [style.width.%]="100" 
        [style.height]="'auto'"
        [style.opacity]="0"
        (click)="clickOnImage(image, i)"
        (load)="onImageLoaded(imageElem)" />
</div>